/* BRECCIA · Regalo culotte desde 120 €
   Barra de progreso + capota a juego + selector de culotte en el carrito. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('breccia-regalo-config');
  var CFG = window.BRECCIA_REGALO_CONFIG || (cfgEl ? JSON.parse(cfgEl.textContent) : null);
  if (!CFG) return;

  var TXT = {
    es: {
      faltan: 'Te faltan <b>{x}</b> para conseguir tu <b>culotte de REGALO</b> 🎁',
      valorado: '(valorado en {v})',
      conseguido: '¡Conseguido! Tienes un <b>culotte de REGALO</b> 🎁',
      capota: 'Completa el conjunto: capota o patucos',
      capota_nota: 'Con cualquiera de los dos llegas a 120 € y te regalamos el culotte',
      bebe: 'Completa el conjunto',
      bebe_nota: 'Con el arrullo, o con capota y patucos, llegas a 120 € y te regalamos el culotte',
      anadir: 'Añadir',
      elige: 'Elige tu culotte de regalo',
      gratis: 'Añadir GRATIS',
      en_carrito: '✓ Tu culotte de regalo ya está en el carrito',
      aviso: 'El culotte solo es gratis a partir de 120 €',
      talla: 'Talla',
      unica: 'Talla única'
    },
    it: {
      faltan: 'Ti mancano <b>{x}</b> per ottenere la tua <b>culotte in REGALO</b> 🎁',
      valorado: '(del valore di {v})',
      conseguido: 'Fatto! Hai una <b>culotte in REGALO</b> 🎁',
      capota: 'Completa il completino: cuffietta o scarpine',
      capota_nota: 'Con una delle due arrivi a 120 € e ti regaliamo la culotte',
      bebe: 'Completa il completino',
      bebe_nota: 'Con la copertina, o con cuffietta e scarpine, arrivi a 120 € e ti regaliamo la culotte',
      anadir: 'Aggiungi',
      elige: 'Scegli la tua culotte in regalo',
      gratis: 'Aggiungi GRATIS',
      en_carrito: '✓ La tua culotte in regalo è nel carrello',
      aviso: 'La culotte è gratuita solo da 120 €',
      talla: 'Taglia',
      unica: 'Taglia unica'
    },
    fr: {
      faltan: 'Plus que <b>{x}</b> pour obtenir votre <b>culotte OFFERTE</b> 🎁',
      valorado: '(d’une valeur de {v})',
      conseguido: 'Bravo ! Votre <b>culotte est OFFERTE</b> 🎁',
      capota: 'Complétez l’ensemble : bonnet ou chaussons',
      capota_nota: 'Avec l’un des deux, vous atteignez 120 € et la culotte est offerte',
      bebe: 'Complétez l’ensemble',
      bebe_nota: 'Avec la couverture, ou le bonnet et les chaussons, vous atteignez 120 € et la culotte est offerte',
      anadir: 'Ajouter',
      elige: 'Choisissez votre culotte offerte',
      gratis: 'Ajouter GRATUITEMENT',
      en_carrito: '✓ Votre culotte offerte est dans le panier',
      aviso: 'La culotte est offerte seulement à partir de 120 €',
      talla: 'Taille',
      unica: 'Taille unique'
    },
    en: {
      faltan: 'You’re <b>{x}</b> away from getting your <b>FREE bloomer</b> 🎁',
      valorado: '(worth {v})',
      conseguido: 'Done! You get a <b>FREE bloomer</b> 🎁',
      capota: 'Complete the set: bonnet or booties',
      capota_nota: 'With either one you reach 120 € and the bloomer is on us',
      bebe: 'Complete the set',
      bebe_nota: 'With the blanket, or the bonnet and booties, you reach 120 € and the bloomer is on us',
      anadir: 'Add',
      elige: 'Choose your free bloomer',
      gratis: 'Add FREE',
      en_carrito: '✓ Your free bloomer is in the cart',
      aviso: 'The bloomer is only free from 120 €',
      talla: 'Size',
      unica: 'One size'
    }
  };
  var T = TXT[(CFG.idioma || 'es').slice(0, 2)] || TXT.es;

  function rate() {
    try { return parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) { return 1; }
  }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function hkey(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  // Talla = primera opción; color = la opción cuyo valor coincide con algún color conocido
  function tallaOf(item) { var o = item.options_with_values || []; return o[0] ? o[0].value : ''; }
  function colorOf(item) {
    var o = item.options_with_values || [];
    for (var i = 1; i < o.length; i++) {
      var k = hkey(o[i].value);
      if ((CFG.capotas || {})[k] || (CFG.patucos || {})[k] || (CFG.arrullos || {})[k]) return o[i].value;
    }
    return '';
  }

  // Talla del conjunto -> talla de capota / culotte
  function tallaCapota(t) {
    t = norm(t);
    if (t === '0-1m') return '0m';
    if (t === '6m' || t === '9m') return '6-9m';
    if (t === '12m' || t === '18m') return '12-24m';
    return t;
  }
  function tallaCulotte(t) {
    t = norm(t);
    if (t === '3m' || t === '6m' || t === '9m') return 'xs';
    if (t === '12m' || t === '18m') return 's';
    return 'xxs';
  }

  function isCulotte(item) { return (CFG.culotte_ids || []).indexOf(item.product_id) !== -1; }
  function isCapota(item) { return /^(capota|patucos)/i.test(item.handle || ''); }
  function isConjunto(item) { return (CFG.pp_ids || []).indexOf(item.product_id) !== -1; }
  function isBebe(item) { return (CFG.bebe_ids || []).indexOf(item.product_id) !== -1; }

  function byColor(map, color) {
    var c = hkey(color);
    return (c && map && map[c]) || null;
  }
  function capotaFor(color) { return byColor(CFG.capotas, color); }
  function patucosFor(color) { return byColor(CFG.patucos, color); }
  function arrulloFor(color) { return byColor(CFG.arrullos, color); }

  function itemHtml(it, pref, match) {
    var precio = it.variantes[0] ? it.variantes[0].precio : 0;
    var disp = it.variantes.filter(function (v) { return v.disponible; });
    var sel = selectHtml(it.variantes, pref, match);
    if (disp.length === 1) sel = sel.replace('<select class="bg-select"', '<select class="bg-select bg-select--hidden"') + '<span class="bg-unica">' + T.unica + '</span>';
    return '<div class="bg-up__item">' +
      '<img src="' + esc(it.imagen) + '" alt="' + esc(it.titulo) + '" width="56" height="56" loading="lazy">' +
      '<div class="bg-up__txt"><p class="bg-up__n">' + esc(it.titulo) + ' · <b>' + money(Math.round(precio * rate()), CUR) + '</b></p>' +
      '<div class="bg-up__row">' + sel + '<button type="button" class="bg-btn" data-bg-add>' + T.anadir + '</button></div></div></div>';
  }

  function selectHtml(variants, preferida, match) {
    var html = '<select class="bg-select" aria-label="' + T.talla + '">';
    var elegido = false;
    variants.forEach(function (v) {
      if (!v.disponible) return;
      var sel = !elegido && match(v.talla, preferida);
      if (sel) elegido = true;
      html += '<option value="' + v.id + '"' + (sel ? ' selected' : '') + '>' + esc(v.talla) + '</option>';
    });
    return html + '</select>';
  }

  var busy = false, CUR = 'EUR';
  function render(cart) {
    var boxes = document.querySelectorAll('[data-breccia-regalo]');
    if (!boxes.length) return;
    var cur = cart.currency; CUR = cur;
    var umbral = Math.round(CFG.umbral * rate());
    var base = 0, hasCul = false, hasCap = false, conj = null, bebe = null, pids = [];
    cart.items.forEach(function (it) {
      pids.push(it.product_id);
      if (isCulotte(it)) { hasCul = true; return; }
      base += it.original_line_price;
      if (isCapota(it)) hasCap = true;
      if (!conj && isConjunto(it)) conj = it;
      if (!bebe && isBebe(it)) bebe = it;
    });
    var falta = umbral - base;
    var pct = Math.max(4, Math.min(100, Math.round(base / umbral * 100)));
    var html = '';

    if (cart.item_count === 0) { boxes.forEach(function (b) { b.innerHTML = ''; }); return; }

    if (falta > 0) {
      html += '<p class="bg-msg">' + T.faltan.replace('{x}', money(falta, cur)) +
              ' <span class="bg-valor">' + T.valorado.replace('{v}', money(Math.round(CFG.valor_culotte * rate()), cur)) + '</span></p>';
      html += '<div class="bg-bar"><span style="width:' + pct + '%"></span></div>';
      if (hasCul) html += '<p class="bg-valor" style="margin:6px 0 0">' + T.aviso + '</p>';
      if (conj && !hasCap) {
        var color = colorOf(conj), talla = tallaOf(conj);
        var cap = capotaFor(color), pat = patucosFor(color);
        if (cap || pat) {
          var m = function (vt, pref) { return norm(vt).indexOf(pref) === 0; };
          html += '<div class="bg-up"><p class="bg-up__t">' + T.capota + '</p>' +
            '<p class="bg-up__s">' + T.capota_nota + '</p>' +
            (cap ? itemHtml(cap, tallaCapota(talla), m) : '') +
            (pat ? itemHtml(pat, '', m) : '') + '</div>';
        }
      } else if (!conj && bebe) {
        var bc = colorOf(bebe), bt = tallaOf(bebe);
        var mm = function (vt, pref) { return norm(vt).indexOf(pref) === 0; };
        var sug = [[arrulloFor(bc), ''], [capotaFor(bc), tallaCapota(bt)], [patucosFor(bc), '']].filter(function (x) {
          return x[0] && pids.indexOf(x[0].pid) === -1;
        });
        if (sug.length) {
          html += '<div class="bg-up"><p class="bg-up__t">' + T.bebe + '</p><p class="bg-up__s">' + T.bebe_nota + '</p>' +
            sug.map(function (x) { return itemHtml(x[0], x[1], mm); }).join('') + '</div>';
        }
      }
    } else {
      html += '<p class="bg-msg bg-ok">' + T.conseguido + '</p>';
      html += '<div class="bg-bar bg-bar--ok"><span style="width:100%"></span></div>';
      if (hasCul) {
        html += '<p class="bg-done">' + T.en_carrito + '</p>';
      } else {
        var ref = conj || bebe;
        var tallaC = tallaCulotte(ref ? tallaOf(ref) : '');
        html += '<p class="bg-elige">' + T.elige + '</p><div class="bg-cul">';
        (CFG.culottes || []).forEach(function (c) {
          html += '<div class="bg-cul__card"><img src="' + esc(c.imagen) + '" alt="' + esc(c.titulo) + '" loading="lazy">' +
            '<p class="bg-cul__n">' + esc(c.titulo) + '</p>' +
            selectHtml(c.variantes, tallaC, function (vt, pref) { return norm(vt).indexOf(pref + ' ') === 0; }) +
            '<button type="button" class="bg-btn bg-btn--gift" data-bg-add>' + T.gratis + '</button></div>';
        });
        html += '</div>';
      }
    }
    boxes.forEach(function (b) { b.innerHTML = html; });
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  // Recarga el carrito lateral del tema después de añadir
  function reloadThemeCart() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return fetch('/cart?view=ajax', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var tpl = doc.querySelector('template[data-html="content"]');
      var box = document.querySelector('.js-ajax-cart-content');
      if (tpl && box) box.innerHTML = tpl.innerHTML;
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.js-cart-count').forEach(function (el) { el.textContent = c.item_count; });
        render(c);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bg-add]');
    if (!btn || busy) return;
    e.preventDefault();
    var sel = btn.parentNode.querySelector('.bg-select');
    if (!sel || !sel.value) return;
    busy = true; btn.disabled = true; btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
    }).then(reloadThemeCart).catch(function () {}).then(function () { busy = false; });
  });

  // Vuelve a pintar cuando el tema cambia el carrito (cantidades, borrar, añadir)
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 350); }
  var isCartUrl = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var p = of.apply(this, arguments);
      try { if (isCartUrl(input && input.url ? input.url : input)) p.then(soon, soon); } catch (e) {}
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isCartUrl(u)) this.addEventListener('loadend', soon);
    return oo.apply(this, arguments);
  };
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-breccia-regalo]') || n.querySelector('[data-breccia-regalo]'))) { soon(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  refresh();
})();
